
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Base URL for your API
const BaseUrl = process.env.REACT_APP_API_URL;
// const BaseUrl = "http://192.168.88.203:5000";

// --- Asynchronous Thunks ---

// Template Thunk
export const AddTemplate = createAsyncThunk(
    'Template/addTemplate',
    async ({ values }, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${BaseUrl}/template_add`, values);
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message
            );
        }
    }
);

// ---  Async Thunk: Fetch All Templates ---
export const fetchTemplates = createAsyncThunk(
    'Template/fetchTemplates',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`${BaseUrl}/template_view`);
            return response.data || [];
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

// ---  Async Thunk: Update Template ---
export const UpdateTemplate = createAsyncThunk(
    'Template/updateTemplate',
    async ({ id, updatedData }, { rejectWithValue }) => {
        try {
            const response = await axios.put(`${BaseUrl}/template_update/${id}`, updatedData);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);


// ---  Async Thunk: Delete Template ---
export const DeleteTemplate = createAsyncThunk(
    'Template/deleteTemplate',
    async ({ id }, { rejectWithValue }) => {
        try {
            await axios.get(`${BaseUrl}/template_delete/${id}`);
            return id;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);


// --- Redux Slice ---
const TemplateSlice = createSlice({
    name: 'templateslice',
    initialState: {

        TemplateData: [],
        templateLoading: false,
        templateError: null,

    },
    reducers: {},
    extraReducers: (builder) => {
        builder

            .addCase(AddTemplate.pending, (state) => {
                state.templateLoading = true;
                state.templateError = null;
            })
            .addCase(AddTemplate.fulfilled, (state, action) => {
                state.templateLoading = false;
                state.TemplateData = action.payload;
            })
            .addCase(AddTemplate.rejected, (state, action) => {
                state.templateLoading = false;
                state.templateError = action.payload || 'Something went wrong';
            })

            // Fetch Templates
            .addCase(fetchTemplates.pending, (state) => {
                state.templateLoading = true;
                state.templateError = null;
            })
            .addCase(fetchTemplates.fulfilled, (state, action) => {
                state.templateLoading = false;
                state.TemplateData = Array.isArray(action.payload?.data)
                    ? action.payload.data
                    : Array.isArray(action.payload)
                        ? action.payload
                        : [];
            })
            .addCase(fetchTemplates.rejected, (state, action) => {
                state.templateLoading = false;
                state.templateError = action.payload || 'Failed to fetch templates.';
                state.TemplateData = [];
            })

            // Update Template
            .addCase(UpdateTemplate.pending, (state) => {
                state.templateLoading = true;
                state.templateError = null;
            })
            .addCase(UpdateTemplate.fulfilled, (state, action) => {
                state.templateLoading = false;
                const updated = action.payload;
                state.TemplateData = state.TemplateData.map((t) =>
                    t._id === updated._id ? updated : t
                );
            })
            .addCase(UpdateTemplate.rejected, (state, action) => {
                state.templateLoading = false;
                state.templateError = action.payload;
            })

            //  Delete Template
            .addCase(DeleteTemplate.pending, (state) => {
                state.templateLoading = true;
                state.templateError = null;
            })
        .addCase(DeleteTemplate.fulfilled, (state, action) => {
            state.templateLoading = false;
            state.TemplateData = Array.isArray(action.payload.data)
                ? action.payload.data
                : Array.isArray(action.payload)
                    ? action.payload
                    : [];
        })
        .addCase(DeleteTemplate.rejected, (state, action) => {
            state.templateLoading = false;
            state.templateError = action.payload || 'Failed to delete template.';
        });
},
});

// Export the reducer
export default TemplateSlice.reducer;